import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";
import {
  ApplicationInsights,
  DistributedTracingModes,
  IEventTelemetry,
  IExceptionTelemetry,
  IMetricTelemetry,
  ITraceTelemetry,
} from "@microsoft/applicationinsights-web";
import { FunctionComponent } from "react";
import { appInsightsConfig } from "../../config";

const config = appInsightsConfig;
const reactPlugin = new ReactPlugin();
config.extensions = [reactPlugin];
config.distributedTracingMode = DistributedTracingModes.W3C;

const ai = new ApplicationInsights({ config });
ai.loadAppInsights();

export default (Component: FunctionComponent) => withAITracking(reactPlugin, Component);
export const appInsights = ai.appInsights;

export interface TelemetryHook {
  trackMetric: (metric: IMetricTelemetry, customProperties?: { [key: string]: unknown }) => void;
  trackException: (exception: IExceptionTelemetry, customProperties?: { [key: string]: unknown }) => void;
  trackEvent: (event: IEventTelemetry, customProperties?: { [key: string]: unknown }) => void;
  trackTrace: (trace: ITraceTelemetry, customProperties?: { [key: string]: unknown }) => void;
}

export const telemetryHook: TelemetryHook = {
  trackMetric: function (metric: IMetricTelemetry, customProperties?: { [key: string]: unknown }) {
    appInsights.trackMetric(metric, customProperties);
  },
  trackException: function (exception: IExceptionTelemetry, customProperties?: { [key: string]: unknown }) {
    appInsights.trackException(exception, customProperties);
  },
  trackEvent: function (event: IEventTelemetry, customProperties?: { [key: string]: unknown }) {
    appInsights.trackEvent(event, customProperties);
  },
  trackTrace: function (trace: ITraceTelemetry, customProperties?: { [key: string]: unknown }) {
    appInsights.trackTrace(trace, customProperties);
  },
};
